import axios from "axios";
import { UIRoutes } from "../router";

export enum APIRoutesVersions {
  V1 = "/v1",
}

export const APIRoutesBase = {
  DASHBOARD: `${APIRoutesVersions.V1}/Dashboard`,
  AD_BLOCKS: `${APIRoutesVersions.V1}/AdBlocks`,
  AUTH: `${APIRoutesVersions.V1}/Auth`,
  BLOG: `${APIRoutesVersions.V1}/Blog`,
  SUNSCRIBERS: `${APIRoutesVersions.V1}/Subscribes`,
  EMAIL_TEMPLATES: `${APIRoutesVersions.V1}/EmailTemplates`,
  CHANGE_LOGS: `${APIRoutesVersions.V1}/ChangeLogs`,
  CORRELATION: `${APIRoutesVersions.V1}/CORRELATION`,
  CRYPTO_INDEX: `${APIRoutesVersions.V1}/CryptoIndex`,
  FEAR_AND_GREED: `${APIRoutesVersions.V1}/FearGreed`,
  INSTRUMENTS: `${APIRoutesVersions.V1}/Instruments`,
  LAYOUT: `${APIRoutesVersions.V1}/Layout`,
  MAGIC_PAGES: `${APIRoutesVersions.V1}/MagicPages`,
  MAGIC_PAGES_HISTORY: `${APIRoutesVersions.V1}/MagicPagesHistory`,
  NEWS: `${APIRoutesVersions.V1}/News`,
  QUOTES: `${APIRoutesVersions.V1}/Quotes`,
  WIDGETS: `${APIRoutesVersions.V1}/Widgets`,
  USERS: `${APIRoutesVersions.V1}/Users`,
  SYSTEM_SETTINGS: `${APIRoutesVersions.V1}/SystemSettings`,
  CRYPTO_MARKETS: `${APIRoutesVersions.V1}/CryptoMarkets`,
};

export const APIRoutes = {
  ...APIRoutesBase,
  DASHBOARD_INSTRUMENT_MOVEMENTS: `${APIRoutesBase.DASHBOARD}/instrumentMovements`,

  AUTH_LOGIN: `${APIRoutesBase.AUTH}/login`,
  AUTH_FORGOT_PASSWORD_REQUEST: `${APIRoutesBase.AUTH}/forgotPassword/request`,
  AUTH_FORGOT_PASSWORD_CHANGE: `${APIRoutesBase.AUTH}/forgotPassword/change`,

  INSTRUMENT_FOR_INDEX: `${APIRoutesBase.INSTRUMENTS}/forIndex`,

  LAYOUT_RIBBON: `${APIRoutesBase.LAYOUT}/ribbon`,

  CRYPTO_INDEX_CHART: `${APIRoutesBase.CRYPTO_INDEX}/Chart`,
  CRYPTO_INDEX_VOLATILITY_CHART: `${APIRoutesBase.CRYPTO_INDEX}/VolatilityChart`,
  CRYPTO_INDEX_PERIOD_PL_CHART: `${APIRoutesBase.CRYPTO_INDEX}/PeriodPLChart`,
  CRYPTO_INDEX_HEAT_MAP_CHART: `${APIRoutesBase.CRYPTO_INDEX}/HeatMapChart`,

  CRYPTO_MARKETS_CAPITALIZATION: `${APIRoutesBase.CRYPTO_MARKETS}/MarketCapitalization`,
  CRYPTO_MARKETS_COMPATIVE_PERFORMANCE: `${APIRoutesBase.CRYPTO_MARKETS}/CompativePerformance`,
  CRYPTO_MARKETS_TRADING_VOLUMES: `${APIRoutesBase.CRYPTO_MARKETS}/TradingVolumes`,

  MAGIC_PAGES_HISTORY_FOR_PAGE: `${APIRoutesBase.MAGIC_PAGES_HISTORY}/forPage`,

  NEWS_TAKE: `${APIRoutesBase.NEWS}/Take`,

  QUOTES_FOR_INSTRUMENT: `${APIRoutesBase.QUOTES}/ForInstrument`,
  QUOTES_VOLATILITY_FOR_INSTRUMENT: `${APIRoutesBase.QUOTES}/VolatilityForInstrument`,
  QUOTES_TRADING_VOLUMES_FOR_INSTRUMENT: `${APIRoutesBase.QUOTES}/TradingVolumesChartForInstrument`,
};

const $api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

function getTimeZoneOffsetToUct() {
  return new Date().getTimezoneOffset() / 60;
}

$api.interceptors.request.use((config: any) => {
  if (config?.url.indexOf("login") === -1) {
    config.headers.Authorization = `Bearer ${localStorage.getItem(
      "48bceb9d-e1a4-4c77-9d62-9b0e9748c07e"
    )}`;
  }
  config.headers.timezoneOffset = getTimeZoneOffsetToUct();

  return config;
});

$api.interceptors.response.use(
  (response: any) => {
    return response;
  },
  (error: any) => {
    if (error.response?.status === 401 || error.response?.status === 403) {
      window.location.href = `/${UIRoutes.ACCOUNT}/${UIRoutes.LOGIN}`;

      return Promise.reject(error);
    }
    return Promise.reject(error);
  }
);
export default $api;
